import { cva } from 'class-variance-authority';

// the follwing rule is disabled because the arbitrary value is used to set the max-width
// on the medium size variant as max-w-[640px], but corresponds to some oficial tailwind class.
// we want to use our own sizes and not tailwind classes that can change values without notice.
//
// eslint-disable-next-line tailwindcss/no-unnecessary-arbitrary-value
export const modalVariants = cva(
  [
    'flex',
    'flex-col',
    'data-[state=open]:animate-contentShow',
    'bg-color-comp-modal-container',
    'text-color-ref-text-strong',
    'fixed',
    'left-1/2',
    'top-1/2',
    'max-h-[85vh]',
    'w-full',
    '-translate-x-1/2',
    '-translate-y-1/2',
    'rounded-radius-sys-radius-8',
    'shadow-box-shadow-sys-high',
    // No bottom padding: the body and the footer each carry their own 16px, and
    // the footer sits flush against this edge as it does in Figma.
    // overrides common lib default giving focused items a white outline
    'focus:outline-none',
  ],
  {
    variants: {
      size: {
        small: 'max-w-[512px]',
        medium: 'max-w-[640px]',
        large: 'max-w-[860px]',
      },
      yPos: {
        middle: '',
        top: 'top-[10vh] -translate-y-0',
      },
    },
    defaultVariants: {
      size: 'medium',
      yPos: 'middle',
    },
  },
);
